// extracted by mini-css-extract-plugin
module.exports = {"learningNav":"navigation_learningNav__2pdrp"};